import { createSelector } from 'reselect';
import { createFeatureSelector } from 'features/create-feature-selector';

const reviewsFeatureSelector = createFeatureSelector('reviews');
export const getReviewsSorting = createSelector(reviewsFeatureSelector, (f) => f.reviewsSorting);
export const getReviewsByScoreFilters = createSelector(
  reviewsFeatureSelector,
  (f) => f.reviewsFilters.byScore,
);

export const getReviewsRatingTotal = createSelector(reviewsFeatureSelector, (f) => f.reviews?.rating.total);

export const checkIfReviewsAreLoaded = createSelector(
  reviewsFeatureSelector,
  (f) => !!f.reviews?.reviewsCards?.length && f.reviewsError === null,
);

export const getReviewsProductId = createSelector(reviewsFeatureSelector, (f) => f.reviews?.productId);
export const getReviewsPageMeta = createSelector(reviewsFeatureSelector, (f) => f.reviews?.pageMeta ?? null);
export const getReviewsCards = createSelector(reviewsFeatureSelector, (f) => f.reviews?.reviewsCards ?? []);
export const getReviewsPerPage = createSelector(
  reviewsFeatureSelector,
  (f) => f.reviews?.pageMeta.reviewsPerPage,
);
export const getReviewsPagination = createSelector(reviewsFeatureSelector, (f) => f.pagination);
export const getPaginationError = createSelector(
  reviewsFeatureSelector,
  (r) => r?.paginationLastPageError ?? null,
);
export const isReviewsPaginationPageLoading = createSelector(
  reviewsFeatureSelector,
  (f) => f.paginationPageIsLoading,
);
export const areReviewsLoading = createSelector(reviewsFeatureSelector, (f) => f?.reviewsLoading ?? false);

export const getReviewsAllPhotos = createSelector(reviewsFeatureSelector, (f) => {
  return f.reviews?.allPhotos ?? [];
});

const getReviewsPhotosModal = createSelector(reviewsFeatureSelector, (f) => f?.photosModal ?? null);
export const isReviewsPhotosModalShowed = createSelector(
  getReviewsPhotosModal,
  (pm) => pm?.isShowed ?? false,
);
export const getReviewsPhotosModalCurrentShowed = createSelector(
  getReviewsPhotosModal,
  (pm) => pm?.currentShowed ?? null,
);

export const getReviewsOpinions = createSelector(reviewsFeatureSelector, (f) => f?.opinions.records ?? []);
export const getLikeDislikeVoterId = createSelector(reviewsFeatureSelector, (f) => f.opinions.voterId);

export const photosUploadHasError = createSelector(reviewsFeatureSelector, (f) =>
  f.selectedPhotos.some(({ processingIsFailed }) => {
    // eslint-disable-next-line no-console
    console.log('processingIsFailed', processingIsFailed);
    return processingIsFailed;
  }),
);
